const sideBar = {
  subheaders: {
    sales: 'Sales',
    storeSetup: 'Store Setup',
    products: 'Products',
    marketing: 'Marketing',
    customers: 'Customer Management',
    endUsers: 'End-Users',
    settings: 'Settings',
    help: 'Help',
    serviceConfiguration: 'Service Configuration',
    monitoring: 'Monitoring',
  },
  titles: {
    dashboard: 'Dashboard',
    products: 'Products',
    stores: 'Stores',
    orders: 'Orders',
    ordersExport: 'Orders Export',
    archivedOrders: 'Archived Orders',
    marketplaceOrders: 'Market Place Orders',
    invoicesExport: 'Invoices export',
    endUsersGroups: 'End-users Groups',
    invoicesCreditNotes: 'Invoices / Credit Notes',
    subscriptions: 'Subscriptions',
    salesCustomers: 'Sales & customers',
    customers: 'Customers',
    endUsers: 'End-Users',
    endUserGroups: 'End-User Groups',
    resellers: 'Resellers',
    marketing: 'Marketing',
    checkoutPageBuilder: 'Checkout Page Builder',
    reports: 'Reports',
    myAccount: 'My Account',
    serviceConfiguration: 'Service Configuration',
    api: 'API',
    servicesConfiguration: 'Services Configuration',
    administration: 'Administration',
    identities: 'Identities',
    notification: 'Notifications',
    licenses: 'Licenses',
    carts: 'Carts',
    localization: 'Localization',
    emailBuilder: 'Email Builder',
    priceModels: 'Price Models',
    priceImportExport: 'Price Import/Export',
    crosSellUpSellReco: 'Crossell Upsell Recommendations',
    fulfillmentPackages: 'Fulfillment packages',
    catalogs: 'Catalogs',
    discountRules: 'Discount rules',
    campaigns: 'Campaigns',
    users: 'Users',
    userRolesProfiles: 'User Roles & Profiles',
    eventNotifications: 'Event Notifications',
    onboarding: 'Onboarding',
    remittables: 'Remittables',
    audits: 'Audits',
    apiDocumentation: 'API Documentation',
    productDocumentation: 'Product Documentation',
    crudHelper: 'C.R.U.D. Helper',
    crudConsole: 'C.R.U.D. Console',
    subsidiarymanager: 'Subsidiary Manager',
    referentialManager: 'Referential Manager',
    subsidiaryManager: 'Subsidiary Manager',
    subscriptionMonitoring: 'Subscription Monitoring',
    tncManager: 'T&C Manager',
    customFieldsDefinition: 'Custom fields',
    exportManagement: 'Export Management',
    orderCancellations: 'Order Cancellations',
  },
  buttons: {
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
  },
  labels: {
    nexway: 'Inc. Nexway',
  }
};

export default sideBar;
